<script setup>
import { ref, computed, defineEmits } from "vue";
import Card from "@/components/common/Card.vue";
import csvIcon from "@/assets/csvIcon.svg";
import AmazonS3 from "@/assets/AmazonS3.svg.png";
import Salesforce from "@/assets/Salesforce.svg.png";

import { ChevronLeftIcon } from "@heroicons/vue/24/solid";
import UploadCSVStep2 from "./UploadCSVStep2.vue";
import S3Form from "./S3Form.vue";
import MarketingCloudForm from "./MarketingCloudForm.vue";

const emit = defineEmits(["nested-open", "nested-close"]);

const showComponent1 = ref(false);
const showComponent2 = ref(false);
const showComponent3 = ref(false);

const showNestedCard = ref(false);

const cardElements = ref([
  {
    img: csvIcon,
    title: "Archivo CSV",
    text: "Carga las audiencias de tus eventos, webinars, o cualquier base de datos de forma manual para activarlas en tus campañas de medios digitales.",
    button: "Conectar",
  },
  {
    img: AmazonS3,
    title: "Amazon S3",
    text: "Carga las audiencias de tus eventos, webinars, o cualquier base de datos a tu Bucket S3.",
    button: "Conectar",
  },
  {
    img: Salesforce,
    title: "Marketing Cloud",
    text: "Carga las audiencias de tus eventos, webinars, o cualquier base de datos en Marketing Cloud Data Extension.",
    button: "Conectar",
  },
]);

const isNestedOpen = computed(
  () => showComponent1.value || showComponent2.value || showComponent3.value
);

function openNestedCard() {
  showNestedCard.value = true;
  emit("nested-open");
}

function closeNestedCard() {
  showNestedCard.value = false;
  emit("nested-close");
}

function handleCardButtonClick(title) {
  showComponent1.value = false;
  showComponent2.value = false;
  showComponent3.value = false;

  switch (title) {
    case "Archivo CSV":
      showComponent1.value = true;
      break;
    case "Amazon S3":
      showComponent2.value = true;
      break;
    case "Marketing Cloud":
      showComponent3.value = true;
      break;
  }

  if (isNestedOpen.value) {
    openNestedCard();
  }
}

function handleBackClick() {
  showComponent1.value = false;
  showComponent2.value = false;
  showComponent3.value = false;
  closeNestedCard();
}
</script>

<template>
  <div style="background: white">
    <div v-if="!isNestedOpen">
      <article class="responsive-container">
        <h5 class="create-title my-4">Listas / Selecciona la plataforma</h5>
        <div class="d-flex gap-5">
          <p
            style="
              margin-top: 20px;
              color: rgb(125, 143, 152);
              text-align: justify;
            "
          >
            Selecciona la plataforma para subir una fuente.
          </p>
        </div>
        <section class="card-section">
          <div class="card-row">
            <div class="card-container">
              <Card
                v-for="(card, index) in cardElements"
                :key="index"
                :img="card.img"
                :title="card.title"
                :text="card.text"
                :button="card.button"
                styleClass="card-style"
                @cardButtonClick="handleCardButtonClick(card.title)"
              />
            </div>
          </div>
        </section>
      </article>
    </div>

    <div v-else class="responsive-container">
      <button class="buttons-group d-flex mb-3" @click="handleBackClick">
        <ChevronLeftIcon
          class="text-blue-500 d-flex justify-content-center"
          style="width: 20px; height: 20px"
        />
        <p class="text">Regresar</p>
      </button>

      <UploadCSVStep2 v-if="showComponent1" @closeModal="handleBackClick" />
      <S3Form v-if="showComponent2" @closeModal="handleBackClick" />
      <MarketingCloudForm v-if="showComponent3" @closeModal="handleBackClick" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";

.responsive-container {
  max-width: 100vw;
  width: calc(100vw - 25rem);
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
}

.buttons-group {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    color: $five-color;
  }
}

.text {
  font-size: large;
  font-weight: 600;
  color: $primary-color;
  margin-left: 0.3rem;
  margin-bottom: 0;
  &:hover {
    color: $five-color;
  }
}

.card-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}

.card-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.card-row .card {
  flex: 1;
  margin-bottom: 30px;
  width: 100%;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
}

.card-style {
  max-width: 18rem;
}
</style>
